/*****************************************************************************************************************************************************
 * Revision History
 * 2024-10-24 TBH - Display "mm/dd/yyyy" for any undefined date or date <= 1/1/1900.
 * 2024-10-24 TBH - Fix US phone regex to support phone numbers with extension.
 *****************************************************************************************************************************************************/

export default function myProfile() {
  return {
    minDate: new Date( 1900, 1, 1 ),

    profileList:'',
    peopleList:'' ,
    zotAlertChecked: false,
    businessAddress: '',
    localAddress: '',
    permanentAddress: '',
    phoneDetails: '',
  
    selectedQuarter: '',
    totalCharges: '',
    totalReceipts: '',
    totalRefunds: '',
    showErrorMesage: false,
    showLoader: false,
    detailPageUrl: '',

    formatDate(dateValue) {
      if( dateValue == undefined || dateValue == "" || dateValue == null || dateValue == "N/A" || dateValue == 0 ) 
        return( "mm/dd/yyyy" );
      
      const date = new Date( dateValue );
      if( date <= this.minDate )
        return( "mm/dd/yyyy" );

      const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
      return( date.toLocaleDateString( 'en-US', options ));
    },
    formatPhoneNumber( phoneNumber, phoneContryId ) {
      if( phoneContryId != 261 ) 
        return( phoneNumber );

      let phoneDigits = phoneNumber.replace(/\D/g, ''); // Remove non-numeric characters
      const match = phoneDigits.match(/^(\d{3})(\d{3})(\d{4})(\d*)$/);

      if( !match )
        return( phoneNumber );

      let maskedPhone = `(${match[1]}) ${match[2]}-${match[3]} ${match[4]}`;
      return( maskedPhone.trim());
    },
    formatSSN(ssn) {
    // Your custom logic to format the SSN
      if( ssn != "" ) {
        ssn = `${'x'.repeat(3)}-${'x'.repeat(2)}-${ssn.substring(5,10)}`;
        return( ssn );
      }
    },
    bindProfile() {
      fetch( '/api/UserAPI/GetProfile', { "method": "GET" }).then( response => {
        if (response.ok) {
          return response.json()
        }
      }).then( response => {
        if( response != undefined && response.isSuccess ) {
          this.peopleList = response.people;
          this.phoneDetails = response.phoneDetails;
          this.localAddress = response.localAddress;
          this.businessAddress = response.businessAddress;
          this.permanentAddress = response.permanentAddress;
          this.zotAlertChecked = response.zotAlertChecked;
        } else {
          window.location.href = '/api/login/SignOut';
        }
      });
    },

    init() {
      this.bindProfile();
    }
  }
}